<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-form>
          <v-card class="primary-shadow pa-4">
            <v-card-title>{{
              $vuetify.lang.t('$vuetify.PROFILE')
            }}</v-card-title>
            <v-card-text>
              <v-row class="d-flex align-center">
                <v-col cols="6">
                  <v-text-field
                    v-model="name"
                    :label="$vuetify.lang.t('$vuetify.REGISTER.NAME')"
                    disabled
                    prepend-inner-icon="mdi-account"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="email"
                    :label="$vuetify.lang.t('$vuetify.REGISTER.EMAIL')"
                    disabled
                    prepend-inner-icon="mdi-email"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="phoneNumber"
                    :label="$vuetify.lang.t('$vuetify.REGISTER.PHONE_NUMBER')"
                    disabled
                    prepend-inner-icon="mdi-phone"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="password"
                    :label="$vuetify.lang.t('$vuetify.REGISTER.PASSWORD')"
                    hide-details
                    :required="!userData.Id || userData.Id <= 0"
                    outlined
                    :rules="[passwordRules]"
                    type="password"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="confirmPassword"
                    :label="$vuetify.lang.t('$vuetify.REGISTER.PASSWORD_AGAIN')"
                    hide-details
                    :required="!userData.Id || userData.Id <= 0"
                    outlined
                    type="password"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                class="secondary--text"
                @click="updatePassword()"
              >
                {{ $vuetify.lang.t(`$vuetify.UPDATE_PASSWORD`) }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Profile',
  props: {
    id: String
  },
  data() {
    return {
      editWhitelistDialog: false,
      userData: '',
      confirmPassword: ''
    }
  },
  computed: {
    ...mapGetters('authentication', ['user']),
    name: {
      get() {
        return this.userData.name
      },
      set(val) {
        this.userData.name = val
      }
    },
    email: {
      get() {
        return this.userData.email
      },
      set(val) {
        this.userData.email = val
      }
    },
    phoneNumber: {
      get() {
        return this.userData.phoneNumber
      },
      set(val) {
        this.userData.phoneNumber = val
      }
    },
    password: {
      get() {
        return this.userData.password
      },
      set(val) {
        this.userData.password = val
      }
    },
    passwordRules() {
      if (
        !this.userData.Id ||
        (this.userData.Id <= 0 && !this.autoGeneratePassword)
      ) {
        return v =>
          this.isStrongAndValidPassword(v) ||
          'Password must contain at least 8 characters, 1 number and 1 capital letter'
      }
      return true
    }
  },
  created() {
    this.userData = { ...this.user }
  },
  methods: {
    ...mapActions('users', ['postUser', 'putUserPassword']),
    updateUser() {
      this.postUser({
        Id: this.userData.id,
        Password: this.userData.password
      })
    },
    updatePassword() {
      if (this.userData.password !== this.confirmPassword) {
        this.$store.commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'error',
            message: this.$vuetify.lang.t('$vuetify.PASSWORDS_MUST_MATCH')
          },
          { root: true }
        )
        return
      }
      if (
        !this.isStrongAndValidPassword(this.userData.password) ||
        this.userData.password === ''
      ) {
        this.$store.commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'error',
            message: this.$vuetify.lang.t('$vuetify.PASSWORD_CRITERIA_MISMATCH')
          },
          { root: true }
        )
        return
      }
      this.putUserPassword({
        OwnerId: this.userData.id,
        P1: this.userData.password,
        P2: this.confirmPassword
      })
    },
    isStrongAndValidPassword(password) {
      if (!password) {
        return false
      }
      // Check if password is at least 8 characters long
      if (password.length < 8) {
        return false
      }

      // Has at least one number
      if (!/\d/.test(password)) {
        return false
      }

      // Has at least one capital letter
      if (!/[A-Z]/.test(password)) {
        return false
      }

      return true
    }
  }
}
</script>
